module.exports = __webpack_public_path__ + "static/media/m1sj.5ab36852.png";